import React from 'react'
import Button from '../../ui/Button/Button'
import { formatDateAsDayMontYearHHMM } from '../../utils/date/dateFormat'
import usePromoSchedulesSync from './usePromoSchedulesSync'
import '../../api/ProductsSyncMenu/ProductsSyncMenu.sass'
import './PromoSchedulesSyncButton.sass'

function PromoSchedulesSyncButton() {
  const { lastSyncDate, isSyncing, result, runSync } = usePromoSchedulesSync()

  const dateLabel = lastSyncDate ? formatDateAsDayMontYearHHMM(lastSyncDate) : null
  const summaryLabel = result?.summary || null
  const warningLabel = result?.warning || (result?.ok === false ? result.message : null)
  const titleParts = [
    dateLabel ? `Остання синхронізація: ${dateLabel}` : 'Синхронізація ще не виконувалась',
    summaryLabel,
    warningLabel,
  ].filter(Boolean)

  return (
    <div className="TabBut PromoSchedulesSyncButton">
      {dateLabel ? (
        <span
          className={`PromoSchedulesSyncButton-Date${
            warningLabel ? ' PromoSchedulesSyncButton-Date_warning' : ''
          }`}
          title={titleParts.join('\n')}
        >
          {dateLabel}
        </span>
      ) : null}
      {summaryLabel ? (
        <span
          className={`PromoSchedulesSyncButton-Summary${
            warningLabel ? ' PromoSchedulesSyncButton-Summary_warning' : ''
          }`}
          title={warningLabel || undefined}
        >
          {summaryLabel}
        </span>
      ) : null}
      <Button
        type="button"
        theme="solid"
        fill="accent"
        size={28}
        icon="sync"
        iconPosition="left"
        className={`ProductsSyncMenu-Button PromoSchedulesSyncButton-Button${
          isSyncing ? ' ProductsSyncMenu-Button_syncing' : ''
        }`}
        title={titleParts.join('\n')}
        disabled={isSyncing}
        onClick={runSync}
      >
        Синхронізація
      </Button>
    </div>
  )
}

export default PromoSchedulesSyncButton
